module.exports = __webpack_public_path__ + "static/media/Icon-closed-envelope.5a0cdb30.svg";